<kendo-combobox
    textField="name"
    valueField="id"
    (filterChange)="onFilterChange($event)"
    [data]="assignments"
    [readonly]="readonly"
    [value]="_value"
    [filterable]="true"
    [valuePrimitive]="valuePrimitive"
    [disabled]="disabled"
    (valueChange)="onValueChange($event)"
    [popupSettings]="{ popupClass: 'popup-combo', width: 'auto' }"
    placeholder="Auftrag suchen"
>
    <ng-template kendoComboBoxItemTemplate let-dataItem>
        {{ dataItem.title + " | " + dataItem.internalNumber}}
    </ng-template>
</kendo-combobox>
<a *ngIf="_value && !hideLink" [routerLink]="['/assignment',_value]">Auftrag öffnen</a>
  